class OneLineLinkToStudent {
    constructor(el) {
        this.el = el;
        this.name = this.el.querySelector(".js-graduate-name");
        this.nowrapLine = this.el.querySelector(".js-nowrap-line");

        this.createNowrapLine();
    }

    createNowrapLine() {
        this.nameArray = this.name.innerHTML.split(" ");
        this.lastWordInName = this.nameArray.pop();

        this.name.textContent = this.nameArray.join(" ");
        this.nowrapLine.prepend(this.lastWordInName);
    }
}

window.addEventListener(
    "load",
    document
        .querySelectorAll(".js-student-name-link")
        .forEach(link => new OneLineLinkToStudent(link))
);